import {
    Tooltip,
    Popover,
    Modal
} from 'bootstrap';
import AOS from 'aos';
import axios from 'axios';
import ModuloBox from './plugins/modulobox.js';
import Flickity from 'flickity-fade';
import 'flickity-as-nav-for';
import 'flickity-imagesloaded';
import Masonry from 'masonry-layout';
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import {
    CountUp
} from 'countup.js';

// Desktop - mobile videos

//get all vids
var video = document.querySelectorAll('video')

//add source to video tag
function addSourceToVideo(element, src) {
    var source  = document.createElement('source');
    source.src  = src;
    source.type = 'video/mp4';
    element.appendChild(source);

}

//determine screen size and select mobile or desktop vid
function whichSizeVideo(element, src) {
    var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
    if(windowWidth > 1200) {
        addSourceToVideo(element, src.dataset.desktopVid);
    } else {
        addSourceToVideo(element, src.dataset.mobileVid);
    }
}

//init only if page has videos
function videoSize() {
    if(video !== undefined) {
        video.forEach(function(element, index) {
            whichSizeVideo(
                element, //element
                element //src locations
            );
        });
    }
}

videoSize();


//note IE11 polyfill needed for each, convert to for loop.


// Init Animate On Scroll
AOS.init();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => {
    return new Tooltip(tooltipTriggerEl)
});

// Enable BS Popovers everywhere
const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map((popoverTriggerEl) => {
    return new Popover(popoverTriggerEl)
});

if(document.querySelector('[data-video]')) {
    document.querySelectorAll('[data-video]').forEach((el) => {
        el.addEventListener('click', (event) => {
            document.getElementById('video-in-modal').src = event.currentTarget.dataset.video;
        });
    })
}

if(document.querySelector('.cd-close-info')) {
    document.querySelectorAll('.cd-close-info').forEach((el, i) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();

            document.querySelectorAll('.char').forEach(el => el.classList.remove('show-char'));
            document.querySelectorAll('.cd-close-info').forEach(el => el.parentNode.classList.remove('is-open'));
            el.parentNode.classList.add('is-open');

            setTimeout(() => {
                const itemIndex = Array.from(document.querySelectorAll('.cd-close-info')).indexOf(el) + 1;
                if(document.querySelector('.char' + itemIndex)) {
                    document.querySelector('.char' + itemIndex).classList.add('show-char');
                }
            }, 600);
        });

        if(i === 0) {
            el.click();
        }
    });
}

const handleFlickityViewportChange = (flickity) => {
    flickity.resize();
}

if(document.querySelector('.carousel-applicationprocess')) {
    const flkty3 = new Flickity('.carousel-applicationprocess', {
        cellAlign:      'left',
        wrapAround:     true,
        groupCells:     false,
        contain:        true,
        pageDots:       false,
        draggable:      true,
        adaptiveHeight: true
    });

    window.addEventListener('resize', handleFlickityViewportChange.bind(null, flkty3));
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange.bind(null, flkty3));
    window.addEventListener('load', handleFlickityViewportChange.bind(null, flkty3));
}
if(document.querySelector('.carousel-nav-applicationprocess')) {
    const flkty4 = new Flickity('.carousel-nav-applicationprocess', {
        cellAlign:       'center',
        asNavFor:        '.carousel-applicationprocess',
        pageDots:        false,
        contain:         true,
        prevNextButtons: false
    });
    window.addEventListener('resize', handleFlickityViewportChange.bind(null, flkty4));
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange.bind(null, flkty4));
    window.addEventListener('load', handleFlickityViewportChange.bind(null, flkty4));
}

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

let testimonialFlickity;
if(document.querySelector('.carousel-testimonials')) {
    testimonialFlickity = new Flickity('.carousel-testimonials', {
        groupCells:     true,
        wrapAround:     true,
        setGallerySize: true
    });

    const handleTestimonialFlickityHeightChanges = () => {
        let maxHeight = 0;
        testimonialFlickity.cells.forEach((cell, i) => {
            maxHeight = Math.max(maxHeight, cell.element.scrollHeight);
        });

        document.querySelector('.carousel-testimonials .flickity-viewport').style.height = maxHeight + 'px';
    }

    testimonialFlickity.on('settle', handleTestimonialFlickityHeightChanges);
    window.addEventListener('DOMContentLoaded', handleTestimonialFlickityHeightChanges);
    window.addEventListener('scroll', handleTestimonialFlickityHeightChanges);
}

if(document.querySelector('.read-more-btn')) {
    document.querySelectorAll('.read-more-btn').forEach((el) => {
        const target = el.parentNode.querySelector('.read-more');
        if(target && target.scrollHeight <= 200) {
            el.remove();
        }

        el.addEventListener('click', (event) => {
            event.preventDefault();

            const target = el.parentNode.querySelector('.read-more');
            if(target) {
                if(!target.classList.contains('shown')) {
                    target.style.height = target.scrollHeight + 'px';
                    target.classList.add('shown');

                    el.innerText = el.dataset.readLessText
                } else {
                    target.style.height = '200px';
                    target.classList.remove('shown');
                    el.innerText = el.dataset.readMoreText
                }
            }
            if(testimonialFlickity) {

                setTimeout(() => {

                    let maxHeight = 0;
                    testimonialFlickity.cells.forEach((cell, i) => {
                        maxHeight = Math.max(maxHeight, cell.element.scrollHeight);
                    });

                    document.querySelector('.carousel-testimonials .flickity-viewport').style.height = maxHeight + 'px';
                }, 300);
            }
        });
    })
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Parallax
if(document.querySelector('#parallax')) {
    document.addEventListener("mousemove", parallax);
    const elem = document.querySelector("#parallax");

    function parallax(e) {
        let _w                        = window.innerWidth / 2;
        let _h                        = window.innerHeight / 2;
        let _mouseX                   = e.clientX;
        let _mouseY                   = e.clientY;
        let _depth                    = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        let x                         = `${_depth}`;
        elem.style.backgroundPosition = x;
    }
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div, .page-body :not(a) > img',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"></div>';

    const formData = new FormData(form);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            const gtagData = {
                'event': 'form_submit',
                'label': form.name,
            };

            if(formData.has('email')) {
                gtagData.email = formData.get('email');
            }
            dataLayer.push(gtagData);

            if(form) {
                window.scrollTo({
                    top:      form.getBoundingClientRect().top + window.scrollY - document.querySelector('nav.navbar').scrollHeight - 150,
                    behavior: 'smooth'
                });
            }

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]') || form.querySelector('#' + error);
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur';
    });
}

window.submitForm = submitForm;

if(document.getElementById('application-form')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':                                                               '.png',
            'image/jpeg':                                                              '.jpg',
            'image/jpg':                                                               '.jpg',
            'application/pdf':                                                         '.pdf',
            'application/msword':                                                      '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn togestaan',
        labelIdle:                             'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });

    let currentlySending = false;

    const submitApplicationForm = (gRecaptchaResponse) => {
        const applicationForm = document.getElementById('application-form');
        if(currentlySending === false) {

            currentlySending       = true;
            const submitButton     = applicationForm.querySelector('[type="submit"]');
            submitButton.innerHTML = '<i class="fad fa-circle-notch fa-spin"></i>';
            submitButton.disabled  = true;
            submitButton.classList.add('disabled');

            const formData = new FormData(applicationForm);
            formData.append('g-recaptcha-response', gRecaptchaResponse)
            const validationAlert = document.getElementById('application-form-validation');

            document.querySelectorAll('.invalid-feedback').forEach((element) => {
                if(!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            });

            document.querySelectorAll('.is-invalid').forEach((element) => {
                element.classList.remove('is-invalid');
            });

            validationAlert.classList.add('d-none');
            validationAlert.classList.remove('alert-danger');
            axios.post(applicationForm.action, formData).then((response) => {
                if(response.data.success) {
                    validationAlert.innerHTML = response.data.message;
                    validationAlert.classList.add('alert-success');
                    validationAlert.classList.remove('d-none');

                    if(applicationForm) {
                        window.scrollTo({
                            top:      applicationForm.getBoundingClientRect().top + window.scrollY - document.querySelector('nav.navbar').scrollHeight - 150,
                            behavior: 'smooth'
                        });
                        applicationForm.innerHTML = '';
                    }

                    const gtagData = {
                        'event': 'form_submit',
                        'label': form.name,
                    };

                    if(formData.has('email')) {
                        gtagData.email = formData.get('email');
                    }
                    dataLayer.push(gtagData);
                } else {
                    currentlySending       = false
                    submitButton.innerHTML = 'Verstuur';
                    submitButton.disabled  = false;
                    submitButton.classList.remove('disabled');
                }
            }).catch((exception) => {
                if(exception.response.data.errors) {
                    for(let error in exception.response.data.errors) {
                        const el = applicationForm.querySelector('[name="' + error + '"]') || applicationForm.querySelector('#' + error);
                        el.classList.add('is-invalid');
                        if(el.parentNode.querySelector('.d-none') !== null) {
                            el.parentNode.querySelector('.d-none').classList.remove('d-none');
                        }
                    }
                }

                submitButton.classList.remove('disabled');
                submitButton.disabled  = false;
                submitButton.innerHTML = 'Verstuur';
                currentlySending       = false;
            });
        }
    };

    window.submitApplicationForm = submitApplicationForm;
}

if(document.querySelector('[data-count-up]')) {
    window.addEventListener('scroll', (event) => {
        document.querySelectorAll('.facts-and-figures-item-container').forEach((el) => {
            const countUp = el.querySelector('[data-count-up]');
            if(el.classList.contains('aos-animate') && countUp && !countUp.classList.contains('started')) {
                countUp.classList.add('started');
                new CountUp(countUp, countUp.dataset.countUp, {
                    duration:  3,
                    separator: '.',
                    decimal:   ','
                }).start();
            }
        });
    });

    setTimeout(() => {
        window.dispatchEvent(
            new Event('scroll')
        );
    }, 100);
}

if(document.querySelector('.carousel.carousel-dairy')) {
    const flkty       = new Flickity('.carousel.carousel-dairy', {
        fade: true
    });
    const buttonGroup = document.querySelector('.button-group');

    document.querySelectorAll('.button-group .button').forEach((el) => {
        el.addEventListener('mouseenter', (event) => {
            const index = Array.from(buttonGroup.querySelectorAll('.button')).indexOf(event.currentTarget);

            buttonGroup.querySelectorAll('.button').forEach(el => el.classList.remove('is-selected'));

            if(index >= 0) {
                event.target.classList.add('is-selected');

                flkty.select(index);
            }
        });
    });
}

// Masonry

// init Masonry
if(document.querySelector('.grid')) {
    let grid      = document.querySelector('.grid');
    const masonry = new Masonry(grid, {
        itemSelector:    '.grid-item',
        columnWidth:     '.grid-sizer',
        percentPosition: true,
        gutter:          '.gutter-sizer'
    });

    imagesLoaded(grid).on('progress', function() {
        // layout Masonry after each image loads
        masonry.layout();
    });
}

// //infographic number animation

// // How long you want the animation to take, in ms
// const animationDuration = 2000;
// // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
// const frameDuration = 1000 / 60;
// // Use that to calculate how many frames we need to complete the animation
// const totalFrames = Math.round( animationDuration / frameDuration );
// // An ease-out function that slows the count as it progresses
// const easeOutQuad = t => t * ( 2 - t );

// // The animation function, which takes an Element
// const animateCountUp = el => {
//   let frame = 0;
//   const countTo = parseInt( el.innerHTML, 10 );
//   // Start the animation running 60 times per second
//   const counter = setInterval( () => {
//     frame++;
//     // Calculate our progress as a value between 0 and 1
//     // Pass that value to our easing function to get our
//     // progress on a curve
//     const progress = easeOutQuad( frame / totalFrames );
//     // Use the progress value to calculate the current count
//     const currentCount = Math.round( countTo * progress );

//     // If the current count has changed, update the element
//     if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
//       el.innerHTML = currentCount;
//     }

//     // If we’ve reached our last frame, stop the animation
//     if ( frame === totalFrames ) {
//       clearInterval( counter );
//     }
//   }, frameDuration );
// };

// // Run the animation on all elements with a class of ‘countup’
// const runAnimations = () => {
//   const countupEls = document.querySelectorAll( '#countup' );
//   countupEls.forEach( animateCountUp );
// };


// const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//         console.log(entry.target);
//         runAnimations();
//         observer.unobserve(entry.target);
//     })
// });

// observer.observe(document.querySelector('.infographic .row'));